import { createApi } from '@reduxjs/toolkit/query/react';
import { Api } from 'api';
import { URL } from 'api/ApiUrls';

export const CertBoardApi = createApi({
    reducerPath: 'CertBoardApi',
    baseQuery: Api.fetchBaseQuery,
    tagTypes: ['CertBoard'],
    endpoints: (build) => ({
        getCertBoard: build.query({
            query: (params) => `${URL.CERT_BOARD_LIST}?${params}`,
            providesTags: ['LIST']
        }),
        getCertBoardDetails: build.query({
            query: (params) => `${URL.CERT_BOARD_DETAIL}/${params}`,
            providesTags: ['DETAIL']
        }),
        createCertBoard: build.mutation({
            query: (body) => ({
                url: `${URL.CERT_BOARD_CREATE}`,
                method: 'POST',
                body
            }),
            invalidatesTags: ['LIST']
        }),
        updateCertBoard: build.mutation({
            query: (body) => ({
                url: `${URL.CERT_BOARD_UPDATE}`,
                method: 'POST',
                body: body
            }),
            invalidatesTags: ['LIST', 'DETAIL']
        }),
        deleteCertBoard: build.mutation({
            query: (body) => ({
                url: `${URL.CERT_BOARD_DELETE}/${body}`,
                method: 'DELETE',
                body: body
            }),
            invalidatesTags: ['LIST']
        })
    })
});

export const {
    useGetCertBoardQuery,
    useGetCertBoardDetailsQuery,
    useCreateCertBoardMutation,
    useUpdateCertBoardMutation,
    useDeleteCertBoardMutation
} = CertBoardApi;
